/**
 * @desc 分页
 */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.ResponseDto<defs.device.IPage<defs.device.FirmwareResponseDto>>;
export function request(params: API.device.firmware.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/firmware/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
